module.exports = __webpack_public_path__ + "media/jinChangHome.5509dcc5.mp4";